import { createTypes } from "@/store/utils";

export const CREATE_CREDIT_CARD = createTypes("CREATE_CREDIT_CARD");
export const FETCH_CREDIT_CARDS = createTypes("FETCH_CREDIT_CARDS");
export const FETCH_INVOICES = createTypes("FETCH_INVOICES");
export const REMOVE_CREDIT_CARD = createTypes("REMOVE_CREDIT_CARD");
export const SET_PRIMARY_CARD = createTypes("SET_PRIMARY_CARD");
export const FETCH_PRIMARY_CARD = createTypes("FETCH_PRIMARY_CARD");
export const FETCH_SUBSCRIPTION = createTypes("FETCH_PRIMARY_CARD");
export const CANCEL_SUBSCIPTION = createTypes("CANCEL_SUBSCRIPTION");
export const UPGRADE_SUBSCRIPTION = createTypes("UPGRADE_SUBSCRIPTION");
export const DOWNGRADE_SUBSCRIPTION = createTypes("DOWNGRADE_SUBSCRIPTION");
export const RESUME_SUBSCRIPTION = createTypes("RESUME_SUBSCRIPTION");
export const FETCH_BILLING_HISTORY = createTypes("FETCH_BILLING_HISTORY");
export const SAVE_PLAID_ACCOUNT = createTypes("SAVE_PLAID_ACCOUNT");
export const FETCH_SUBSCRIPTION_PLANS_INFO = createTypes("FETCH_SUBSCRIPTION_PLANS_INFO");
export const FETCH_BANK_ACCOUNTS = createTypes("FETCH_BANK_ACCOUNTS");
export const FETCH_PAYMENT_METHODS = createTypes("FETCH_PAYMENT_METHODS");